import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AbstractService } from './abstract.service';

export type CategoriaBlog = 'novidade' | 'correcao' | 'empreendedorismo' | 'aviso' | 'dica';
export type GrupoMudanca = 'novo' | 'melhoria' | 'correcao';

export interface EnqueteBlog {
  pergunta: string;
  opcoes: { texto: string; votos?: number }[];
}

export const REACOES_BLOG: { chave: string; emoji: string; label: string }[] = [
  { chave: 'gostei', emoji: '👏', label: 'Gostei' },
  { chave: 'util', emoji: '💡', label: 'Útil' },
  { chave: 'amei', emoji: '🎉', label: 'Amei' },
  { chave: 'duvida', emoji: '🤔', label: 'Fiquei com dúvida' },
];

export interface PostBlog {
  id?: number;
  titulo: string;
  categoria: CategoriaBlog;
  versao: string;
  resumo: string;
  texto: string;
  mudancas: Partial<Record<GrupoMudanca, string[]>>;
  destaque: boolean;
  situacao: 'rascunho' | 'publicado';
  publicarEm: string;
  autora?: string;
  votosSim?: number;
  votosNao?: number;
  reacoes?: Record<string, number>;
  enquete?: EnqueteBlog | null;
  criadoEm?: string;
  alteradoEm?: string;
  criadoPor?: string;
  alteradoPor?: string;
}

@Injectable({
  providedIn: 'root',
})
export class BlogService {
  constructor(private http: HttpClient) {}

  posts(): Observable<PostBlog[]> {
    return this.http.get<PostBlog[]>(this.url(), { headers: this.headers() });
  }

  incluir(post: PostBlog): Observable<PostBlog> {
    return this.http.post<PostBlog>(this.url(), post, { headers: this.headers() });
  }

  alterar(id: number, post: PostBlog): Observable<PostBlog> {
    return this.http.put<PostBlog>(this.url(id), post, { headers: this.headers() });
  }

  enviarImagem(arquivo: File): Observable<string> {
    const headers = new HttpHeaders({ 'Content-Type': arquivo.type, 'X-Auth-Token': AbstractService.token() });
    return this.http
      .post<{ url: string }>(environment.blog + '/api/admin/imagens', arquivo, { headers })
      .pipe(map((r) => environment.blog + r.url));
  }

  excluir(id: number): Observable<void> {
    return this.http.delete<void>(this.url(id), { headers: this.headers() });
  }

  linkPost(id?: number): string {
    return environment.blog + (id ? '/?p=' + id : '/');
  }

  imagemHaila(): string {
    return environment.blog + '/haila.png';
  }

  mensagemErro(e: HttpErrorResponse): string {
    if (!e || e.status === 0) {
      return 'Não consegui falar com o servidor do News do Hábil.';
    }
    return e.error?.mensagem || 'Erro inesperado no servidor do News do Hábil.';
  }

  private url(id?: number): string {
    return environment.blog + '/api/admin/posts' + (id ? '/' + id : '');
  }

  private headers(): HttpHeaders {
    return new HttpHeaders({
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json',
      'X-Auth-Token': AbstractService.token(),
    });
  }
}
